import bus from './index';

// Auto-attach to global
if (typeof window !== 'undefined') {
  if (!window.app) {
    (window as any).app = {};
  }
  (window as any).app.event = bus;
} else if (typeof globalThis !== 'undefined') {
  if (!(globalThis as any).app) {
    (globalThis as any).app = {};
  }
  (globalThis as any).app.event = bus;
}

export default bus;